// extracted by mini-css-extract-plugin
export var clickTarget = "IframeModal-module--click-target--2wRa1";
export var repriseButton = "IframeModal-module--reprise-button--3h52P";
export var modal = "IframeModal-module--modal--1xkqH";